/**
 * A result as draughts players write it: 2–0, 1–1, 0–2 (win 2, draw 1).
 *
 * A decided board with no result is a double forfeit — neither player
 * appeared — which FMJD Annex 3 §5.8 scores "zero - zero".
 */
export function scoreline(result: string | null | undefined): string {
  if (result === "draw") return "1–1";
  if (result === "white") return "2–0";
  if (result === "black") return "0–2";
  return "0–0";
}
